import phoneUtils from "intl-tel-input/utils";

export function formatInternationalPhoneNumber(phoneNumber) {
  const value = String(phoneNumber || "").trim();
  if (!value) return "";

  const digits = value.replace(/\D/g, "");
  if (!digits) return value;

  const candidate = value.startsWith("+") ? value : `+${digits}`;

  try {
    if (!phoneUtils.isPossibleNumber(candidate, null)) {
      return value;
    }

    return phoneUtils.formatNumber(
      candidate,
      null,
      phoneUtils.numberFormat.INTERNATIONAL
    ) || value;
  } catch {
    return value;
  }
}
